//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Navigation from '@/components/sobre/NewNavigation.vue';
import Headline from '@/components/sobre/NewHeadline.vue';
import Tabs from '@/components/sobre/NewTabs.vue';
import InformationBlock from './components/InformationBlock.vue';

export default {
  name: 'AboutUs',
  components: {
    Headline,
    Navigation,
    Tabs,
    InformationBlock,
  },
  layout: 'scaled',
  data() {
    return {
      informationBlocks: [
        {
          id: 1,
          imageSrc: 'sobre-career-students-1-1x.png',
          retinaImageSrc: 'sobre-career-students-1-2x.png',
          title: this.$t('career-center-students.step-1.title'),
          description: this.$t('career-center-students.step-1.description'),
        },
        {
          id: 2,
          imageSrc: 'sobre-career-students-2-1x.png',
          retinaImageSrc: 'sobre-career-students-2-2x.png',
          title: this.$t('career-center-students.step-2.title'),
          description: this.$t('career-center-students.step-2.description'),
          reversed: true,
        },
        {
          id: 3,
          imageSrc: 'sobre-career-students-3-1x.png',
          retinaImageSrc: 'sobre-career-students-3-2x.png',
          title: this.$t('career-center-students.step-3.title'),
          description: this.$t('career-center-students.step-3.description'),
        },
        {
          id: 4,
          imageSrc: 'sobre-career-students-4-1x.png',
          retinaImageSrc: 'sobre-career-students-4-2x.png',
          title: this.$t('career-center-students.step-4.title'),
          description: this.$t('career-center-students.step-4.description'),
          reversed: true,
        },
      ],
    };
  },
  head() {
    return {
      bodyAttrs: {
        class: 'career-center-students',
      },
      title: this.$t('meta.careerCenterStudents.title'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.careerCenterStudents.description'),
        },
        {
          hid: 'og:url',
          name: 'og:url',
          property: 'og:url',
          content: `https://${this.$app.config.current.domain}${this.$route.path}`,
        },
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: this.$t('meta.careerCenterStudents.title'),
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('meta.careerCenterStudents.description'),
        },
        {
          hid: 'og:type',
          name: 'og:type',
          property: 'og:type',
          content: 'website',
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: `https://${
            this.$store?.state?.host
          }${require(`~/assets/${this.$app?.config?.common?.currentCountry}/ebac-logo.png`)}`,
        },
      ],
      script: this.$app.config.current.careerCenterStudentsScripts,
    };
  },
};
